import * as React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import PurchasesTable from './PurchasesTable';
import PurchaseRequestsTable from './PurchaseRequestsTable';

export type UserPurchasesSubtab = 'purchases' | 'requests';

/** The user page's Purchases tab: the store purchases and the purchase requests behind them, as subtabs. */
export default function UserPurchasesTab({ userId, initialSubtab = 'purchases' }: {
    userId: number;
    initialSubtab?: UserPurchasesSubtab;
}) {
    const [subtab, setSubtab] = React.useState<UserPurchasesSubtab>(initialSubtab);
    return (
        <Box>
            <Tabs value={subtab} onChange={(_, value: UserPurchasesSubtab) => setSubtab(value)} sx={{ mb: 1 }}>
                <Tab value="purchases" label="Purchases" />
                <Tab value="requests" label="Purchase requests" />
            </Tabs>
            {subtab === 'purchases'
                ? <PurchasesTable userId={userId} />
                : <PurchaseRequestsTable userId={userId} />}
        </Box>
    );
}
